<div class="footer z-0">
  <footer class="container">
    <div class="footer__content row">
      <!-- LOGO - MENU - SLOGAN -->

      <div
        class="row d-flex-column justify-content-xl-between align-items-xl-center"
      >
        <!--COL-SLOGAN TABLET-->
        <div
          class="footer__top-slogan dekstop d-none col-md-12 d-md-flex d-xl-none"
        >
          <img
            ngSrc="../../assets/img/slogan-desktop.svg"
            width="1250"
            height="100"
            alt="Our people make IT nicer"
            class="footer__top-slogan-img"
          />
        </div>
        <!--COL-LOGO-->
        <div class="footer__top-logo-container col-12 col-xl-auto">
          <img
            ngSrc="../../assets/logo/logo-footer.svg"
            width="250"
            height="50"
            alt="NiceProject Logo-white"
            class="footer__top-logo d-inline-block"
          />
        </div>
        <!--COL-SLOGAN MOBILE-->
        <div class="footer__top-slogan col-12 d-md-none">
          <img
            ngSrc="../../assets/img/slogan-mobile.svg"
            width="350"
            height="50"
            alt="Our people make IT nicer"
            class="footer__top-slogan-img"
          />
        </div>
        <!--COL-MENU-->
        <div class="footer__top-menu col-12 col-md-6 col-xl-auto d-flex">
          <div
            class="footer__top-menu-content row d-flex align-items-md-center"
          >
            <div class="footer__top-menu-list d-flex col col-md-12 col-xl-auto">
              <ul
                class="footer__top-menu-links d-flex flex-column flex-xl-row flex-xl-nowrap m-0"
              >
                <li>
                  <button
                    type="button"
                    (click)="scrollTo('about')"
                    class="footer__top-menu-link nav-link"
                    >who we are?</button
                  >
                </li>
                <li>
                  <button
                    type="button"
                    (click)="scrollTo('tech')"
                    class="footer__top-menu-link nav-link"
                    >technologies</button
                  >
                </li>
                <li>
                  <a
                    routerLink="newsroom"
                    class="footer__top-menu-link nav-link"
                    >newsroom</a
                  >
                </li>
              </ul>
            </div>
            <div class="footer__top-menu-list d-flex col col-md-6 col-xl-auto">
              <ul
                class="footer__top-menu-links d-flex flex-column flex-xl-row flex-xl-nowrap m-0"
              >
                <li>
                  <a routerLink="careers" class="footer__top-menu-link nav-link"
                    >careers</a
                  >
                </li>
                <li>
                  <button
                    type="button"
                    (click)="scrollTo('form')"
                    class="footer__top-menu-link nav-link"
                    >contact</button
                  >
                </li>
                <li class="d-flex d-md-none">
                  <a
                    routerLink="privacy-policy"
                    class="footer__top-menu-link nav-link"
                    >privacy policy</a
                  >
                </li>
              </ul>
            </div>
            <div class="col d-none d-xl-block">
              <button
                type="button"
                (click)="scrollTo('hero')"
                class="navbar-icon"
                ><div class="footer__top-menu-icon-container">
                  <img
                    ngSrc="../../assets/icons/scroll-up.svg"
                    width="50"
                    height="50"
                    alt="scroll"
                    class="d-inline-block icon"
                  /></div
              ></button>
            </div>
          </div>
        </div>

        <!-- COL-CONTACT-ONLY FOR TABLET-->
        <div
          class="footer__contact-tab d-none d-md-flex flex-column d-xl-none col-md-auto"
        >
          <div class="footer__contact-tab-privacy d-flex">
            <a routerLink="privacy-policy" class="footer__contact-tab-link"
              >PRIVACY POLICY</a
            >
          </div>
          <div class="footer__contact-tab-contact d-flex flex-column">
            <div>
              <p class="_1r m-0">NiceProject Sp. z o. o.</p>
              <p class="_1r m-0">NIP: 8952136277</p>
            </div>
            <div>
              <p class="_1r m-0">Wybrzeże Stanisława Wyspiańskiego 36 lok. 1</p>
              <p class="_1r m-0">50-370 Wrocław, Poland</p>
            </div>
            <div>
              <p class="_1r m-0">hello&#64;niceproject.eu</p>
            </div>
          </div>
          <div class="footer__contact-tab-socials d-flex">
            <div class="me-4">
              <a
                class="navbar-icon"
                href="https://www.linkedin.com/company/niceproject-sp-z-o-o/mycompany/"
                target="_blank"
                rel="noopener noreferrer"
                ><div class="footer__contact-socials-container">
                  <img
                    ngSrc="../../assets/icons/linkedin.svg"
                    width="50"
                    height="50"
                    alt="Linkedin icon"
                    class="d-inline-block footer__contact-socials-icon"
                  /></div
              ></a>
            </div>
            <div>
              <a
                class="navbar-icon"
                href="https://www.facebook.com/profile.php?id=100084563584784"
                target="_blank"
                rel="noopener noreferrer"
                ><div class="footer__contact-socials-container">
                  <img
                    ngSrc="../../assets/icons/facebook.svg"
                    width="50"
                    height="50"
                    alt="Facebook icon"
                    class="d-inline-block footer__contact-socials-icon"
                  /></div
              ></a>
            </div>
          </div>
        </div>
        <!--COL-SLOGAN DESKTOP-->
        <div class="footer__top-slogan dekstop d-none col-xl-12 d-xl-flex">
          <img
            ngSrc="../../assets/img/slogan-desktop.svg"
            width="1200"
            height="100"
            alt="Our people make IT nicer"
            class="footer__top-slogan-img"
          />
        </div>
      </div>

      <!-- CONTACT INFORMATION -->
      <div
        class="footer__contact row justify-content-between align-items-xl-center d-md-none d-xl-flex"
      >
        <div class="footer__contact-data col-auto col-xl-auto d-flex _3r">
          <div class="footer__contact-address row flex-column flex-xl-row">
            <div class="col-12 col-xl-auto pe-0">
              <p class="_3r m-0">NiceProject Sp. z o. o.</p>
              <p class="footer__contact-address-nip _3r m-md-0">
                NIP: 8952136277
              </p>
            </div>
            <div class="col-12 col-xl-auto pe-0">
              <p class="_3r m-0">Wybrzeże Stanisława Wyspiańskiego 36 lok. 1</p>
              <p class="_3r m-0">50-370 Wrocław, Poland</p>
            </div>
            <div class="col col-xl-auto d-none d-xl-block">
              <p class="_3r">hello&#64;niceproject.eu</p>
            </div>
          </div>
        </div>
        <div class="footer__contact-socials col col-xl-auto">
          <div class="row">
            <div class="col-auto p-0">
              <a
                class="navbar-icon"
                href="https://www.linkedin.com/company/niceproject-sp-z-o-o/mycompany/"
                target="_blank"
                rel="noopener noreferrer"
                ><div class="footer__contact-socials-container">
                  <img
                    ngSrc="../../assets/icons/linkedin.svg"
                    width="50"
                    height="50"
                    alt="Linkedin icon"
                    class="d-inline-block footer__contact-socials-icon"
                  /></div
              ></a>
            </div>
            <div class="col-auto ps-3 ps-xl-5">
              <a
                class="navbar-icon"
                href="https://www.facebook.com/profile.php?id=100084563584784"
                target="_blank"
                rel="noopener noreferrer"
                ><div class="footer__contact-socials-container">
                  <img
                    ngSrc="../../assets/icons/facebook.svg"
                    width="50"
                    height="50"
                    alt="Facebook icon"
                    class="d-inline-block footer__contact-socials-icon"
                  /></div
              ></a>
            </div>
            <div class="col-auto empty-space"></div>
          </div>
        </div>
        <div class="footer__privacy d-none d-xl-flex col-xl-auto">
          <div class="row contact__terms">
            <a class="footer__privacy-link col" routerLink="privacy-policy"
              >PRIVACY <span class="ms-3">POLICY</span></a
            >
          </div>
        </div>
      </div>
      <!-- COPYRIGHTS INFORMATION -->
      <div
        class="footer__copyrights row d-flex justify-content-between align-items-center"
      >
        <div class="col col-md-9">
          <p class="display-3r m-0">© {{ currentYear }} Nice Project</p>
        </div>
        <div
          class="footer__copyrights-design col col-md-3 p-0 d-flex align-items-center justify-content-end"
        >
          <p class="display-3r m-0">Designed by</p>

          <img
            ngSrc="../../assets/logo/logo_develtio 1.svg"
            width="60"
            height="25"
            alt="Develtio logo"
            class="footer__copyrights-logo d-inline-block"
          />
        </div>
      </div>
    </div>
  </footer>
</div>
